import CityPageTemplate from "../city-template/CityPageTemplate";
import { strongsvilleConfig } from "./data";

export default function StrongsvillePage() {
  return <CityPageTemplate config={strongsvilleConfig} />;
}